import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FileUpload } from "primereact/fileupload";

import { TextInputField, CalendarField, Button } from '../../../helpers';

import Loading from '../../../common/Loading';
import FileViewAndRemove from '../../../common/FileViewAndRemove';

import { getDocCopyByDocNo } from '../../../services/api/docCopy';
import { raiseToast } from '../../../services/redux/reducers/toast/toast';

import downloadFile from '../../../utils/DownloadFile';
import { getDateString, getFullName, getUploadedFileObj } from '../../../utils';
import { getPMCompanyConfig } from '../../../setup/pmCompanyConfig';


const DeliveryDetails = (props) => {
    const { editedDeliveryChallan, previousDeliveryChallan, buyerInvoice, deliveryChallanUpdatedUser } = props

    const dispatch = useDispatch()
    const [minPODDate, setminPODDate] = useState(new Date())
    const [isPDFLoading, setIsPDFLoading] = useState(false)

    const userDetails = useSelector(state => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    useEffect(() => {
        let minimumDate = new Date()
        minimumDate.setHours(0)
        minimumDate.setMinutes(0)
        minimumDate.setDate(minimumDate.getDate() - 34)
        
        // minimumDate.setDate(26)
        // minimumDate.setMonth(0)
        setminPODDate(minimumDate)
    }, [])

    const handledeliveryChallanInputChange = (event) => {
        editedDeliveryChallan[event.target.name] = event.target.value
        props.setEditedDeliveryChallan({...editedDeliveryChallan})
    }

    const handleDownloadDC = async () => {
        setIsPDFLoading(true)
        const generateIfNotExists = true
        const docCopyRes = await getDocCopyByDocNo(previousDeliveryChallan.docNo, generateIfNotExists)

        if(docCopyRes.failure){
            setIsPDFLoading(false)
            return dispatch(raiseToast({severity:'error', summary: "Delivery Challan Document", detail:docCopyRes.data.error}))
        }
        
        if(!docCopyRes.docLocation){
            setIsPDFLoading(false)
            return dispatch(raiseToast({severity:'error', summary: "Delivery Challan Document", detail: "Delivery Challan document was not found."}))
        }

        downloadFile(docCopyRes.docLocation, `deliveryChallan_${previousDeliveryChallan.docNo}.pdf`)
        setIsPDFLoading(false)
    }

    const fileUploadHandler = async ({ files, options }) => {
        const { fileArr, error, errorMsg } = await getUploadedFileObj({ files, options })
        if (error) {
            return dispatch(raiseToast({ severity: 'error', detail: errorMsg, life: 3000 }))
        }
        const fileObj = fileArr[0]
        uploadPODDocument(fileObj.objectURL, fileObj.name, fileObj.dataURI)
    }

    const uploadPODDocument = async (fileURL, fileName, dataURI) => {
        let data = {
            url: fileURL,
            documentName: "DC_POD",
            fileName,
            dataURI,
            objectURL: fileURL
        }
        editedDeliveryChallan.docProof = data
        props.setEditedDeliveryChallan({ ...editedDeliveryChallan })
    }

    const removeDOCProof = () => {
        editedDeliveryChallan.docProof = null
        props.setEditedDeliveryChallan({ ...editedDeliveryChallan })
    }

    let minimumPODDate = minPODDate
    if(buyerInvoice && Date.parse(minimumPODDate) < Date.parse(buyerInvoice.createdAt)){
        minimumPODDate = new Date(buyerInvoice.createdAt)
        minimumPODDate.setHours(0)
        minimumPODDate.setMinutes(0)
    }

    if(pmCompanyConfig.isInternational){
        let minimumDate = new Date()
        minimumDate.setHours(0)
        minimumDate.setMinutes(0)
        minimumDate.setDate(minimumDate.getDate() - 90)

        minimumPODDate = minimumDate
    }
    
    return (
        <>
            <div className="flex flex-row justify-content-between">
                <h4 className="mt-0  mb-2">Delivery Details</h4>
                <div>
                    <h5>{previousDeliveryChallan?.docProof ? 'Uploaded By: ' : 'Created By: '} {getFullName(deliveryChallanUpdatedUser?.firstName, deliveryChallanUpdatedUser?.lastName)} On {getDateString(previousDeliveryChallan?.updatedAt)}</h5>
                </div>
            </div>
            <div className="">
                <div className="grid">
                    <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                        <CalendarField 
                            name="deliveredOn" 
                            labelText="Delivered On" 
                            placeholder="" 
                            value={editedDeliveryChallan?.deliveredOn ? new Date(editedDeliveryChallan.deliveredOn) : null} 
                            maxDate={new Date()} 
                            minDate={minimumPODDate} 
                            onChange={(event)=>handledeliveryChallanInputChange(event)} 
                            errorMessage={ props.deliveryChallanFormErrors?.deliveredOn } 
                            required 
                            disabled={previousDeliveryChallan?.deliveredOn && !editedDeliveryChallan?.isEditable} 
                        />
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                        <TextInputField name="deliveredTo" labelText="Delivered To" value={editedDeliveryChallan?.deliveredTo} onChange={(event)=>handledeliveryChallanInputChange(event)} errorMessage={ props.deliveryChallanFormErrors?.deliveredTo } required disabled={previousDeliveryChallan?.deliveredTo} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                        <TextInputField name="deliveredNote" labelText="Delivered Note" value={editedDeliveryChallan?.deliveredNote} onChange={(event)=>handledeliveryChallanInputChange(event)} errorMessage={ props.deliveryChallanFormErrors?.deliveredNote } required disabled={previousDeliveryChallan?.deliveredNote} />
                    </div>
                    <div className="flex flex-column ml-2 mt-4">
                        <Button label='Download D.C' className="small-btn" onClick={() => handleDownloadDC()}/>
                    </div>
                </div>
                <div className="grid upload-file mt-2">
                    <div className="flex align-items-center col-12 mb-2">
                        <label htmlFor="docProof" className="text-xs mb-1 mr-2">POD Doc<span style={{ color: "red" }} className="from-required">*</span>: </label>
                        {
                            !editedDeliveryChallan.docProof || editedDeliveryChallan.isEditable ?
                                <div className="mr-2">
                                    <FileUpload mode="basic" name="docProof" accept="image/pdf/*" customUpload auto multiple chooseLabel="Upload Document" uploadHandler={(files) => fileUploadHandler(files)} />
                                </div>
                                : null
                        }
                        {
                            editedDeliveryChallan.docProof ?
                                typeof (editedDeliveryChallan.docProof) === 'string' ?
                                    <>
                                        <div className='mb-1'>
                                            <FileViewAndRemove doc={{url: editedDeliveryChallan.docProof}} />
                                        </div>
                                    </>
                                    :
                                    <div className='flex justify-content-center align-items-center ml-2'>
                                        <FileViewAndRemove doc={{url: editedDeliveryChallan.docProof}} showRemove handleRemoveDoc={removeDOCProof} />
                                    </div>
                                : null
                        }
                        {/*<div className="flex align-items-center col-12 mb-2">
                            <label htmlFor="docProof" className="text-xs mb-1 mr-2">POD Doc<span style={{ color: "red" }} className="from-required">*</span>: </label>
                            {
                                !editedDeliveryChallan?.docProof ?
                                    <div>
                                        <FileUpload mode="basic" name="docProof" accept="image/pdf/*" customUpload auto multiple chooseLabel="Upload Document" uploadHandler={(files) => fileUploadHandler(files)} />
                                    </div>
                                    :
                                    <FileViewAndRemove doc={{url:editedDeliveryChallan.docProof}} showRemove handleRemoveDoc={removeDOCProof} />
                            }
                        </div>*/}
                    </div>
                </div>
                <Loading visible={isPDFLoading} />
            </div>
        </>
    )
}

export default DeliveryDetails